'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyles = undefined;

var _templateObject = _taggedTemplateLiteral([''], ['']);

exports.FilterBarComponent = FilterBarComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _moveto = require('moveto');

var _moveto2 = _interopRequireDefault(_moveto);

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

var _withFilter = require('@bd/bdcore-data/build/Filters/withFilter');

var _withFilter2 = _interopRequireDefault(_withFilter);

var _Filters = require('./Filters');

var Filters = _interopRequireWildcard(_Filters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

function scrollToTop(ref) {
  setTimeout(function () {
    var moveTo = new _moveto2.default({
      tolerance: 100
    });
    moveTo.move(ref);
  }, 100);
}

function FilterBarComponent(_ref) {
  var builderId = _ref.builderId,
      className = _ref.className,
      filterOptions = _ref.filterOptions,
      onSelectScrollTo = _ref.onSelectScrollTo,
      routeName = _ref.routeName,
      type = _ref.type;

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'div',
      { className: 'FilterBar_wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'FilterBar_inner' },
        _react2.default.createElement(
          'ul',
          { className: 'FilterBar_list' },
          filterOptions.map(function (options) {
            var RawFilter = (0, _lodash.get)(Filters, '' + options.type);
            if (RawFilter) {
              var Filter = (0, _withFilter2.default)(options.filter)(RawFilter);

              return _react2.default.createElement(
                'li',
                { key: options.type + '.' + options.filter, className: 'FilterBar_listItem' },
                _react2.default.createElement(Filter, Object.assign({}, options, {
                  builderId: builderId,
                  filterType: options.type,
                  type: type,
                  title: options.title,
                  placeholder: options.placeholder,
                  onSelect: function onSelect() {
                    return scrollToTop(onSelectScrollTo);
                  },
                  routeName: routeName
                }))
              );
            }
            return null;
          })
        )
      )
    )
  );
}

FilterBarComponent.propTypes = {
  builderId: _propTypes2.default.string,
  className: _propTypes2.default.string,
  filterOptions: _propTypes2.default.arrayOf(_propTypes2.default.object),
  onSelectScrollTo: _propTypes2.default.object,
  routeName: _propTypes2.default.string,
  type: _propTypes2.default.string.isRequired
};
FilterBarComponent.defaultProps = {
  builderId: undefined,
  className: undefined,
  filterOptions: [],
  onSelectScrollTo: undefined,
  routeName: undefined
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(FilterBarComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-filterbar/build/FilterBar.js
// module id = 992
// module chunks = 0